import _defineProperty from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { HTMLElement, h, Host, proxyCustomElement } from '@stencil/core/internal/client';
import { b as getIonMode } from './ionic-global.js';
var fabCss = ":host{position:absolute;z-index:999}:host(.fab-horizontal-center){left:50%;margin-left:-28px}:host-context([dir=rtl]):host(.fab-horizontal-center),:host-context([dir=rtl]).fab-horizontal-center{left:unset;right:unset;right:50%}@supports ((-webkit-margin-start: 0) or (margin-inline-start: 0)) or (-webkit-margin-start: 0){:host(.fab-horizontal-center){margin-left:unset;-webkit-margin-start:-28px;margin-inline-start:-28px}}:host(.fab-horizontal-start){left:calc(10px + var(--ion-safe-area-left, 0px))}:host-context([dir=rtl]):host(.fab-horizontal-start),:host-context([dir=rtl]).fab-horizontal-start{left:unset;right:unset;right:calc(10px + var(--ion-safe-area-left, 0px))}:host(.fab-horizontal-end){right:calc(10px + var(--ion-safe-area-right, 0px))}:host-context([dir=rtl]):host(.fab-horizontal-end),:host-context([dir=rtl]).fab-horizontal-end{left:unset;right:unset;left:calc(10px + var(--ion-safe-area-right, 0px))}:host(.fab-vertical-top){top:10px}:host(.fab-vertical-top.fab-edge){top:-28px}:host(.fab-vertical-bottom){bottom:10px}:host(.fab-vertical-bottom.fab-edge){bottom:-28px}:host(.fab-vertical-center){margin-top:-28px;top:50%}";

var Fab = /*#__PURE__*/function (_HTMLElement) {
  _inherits(Fab, _HTMLElement);

  var _super = _createSuper(Fab);

  function Fab() {
    var _this;

    _classCallCheck(this, Fab);

    _this = _super.call(this);

    _this.__registerHost();

    _this.__attachShadow();
    /**
     * If `true`, the fab will display on the edge of the header if
     * `vertical` is `"top"`, and on the edge of the footer if
     * it is `"bottom"`. Should be used with a `fixed` slot.
     */


    _this.edge = false;
    /**
     * If `true`, both the `ion-fab-button` and all `ion-fab-list` inside `ion-fab` will become active.
     * That means `ion-fab-button` will become a `close` icon and `ion-fab-list` will become visible.
     */

    _this.activated = false;

    _this.onClick = function () {
      var hasList = !!_this.el.querySelector('ion-fab-list');

      var getButton = _this.getFab();

      var isButtonDisabled = getButton && getButton.disabled;

      if (hasList && !isButtonDisabled) {
        _this.activated = !_this.activated;
      }
    };

    return _this;
  }

  _createClass(Fab, [{
    key: "activatedChanged",
    value: function activatedChanged() {
      var activated = this.activated;
      var fab = this.getFab();

      if (fab) {
        fab.activated = activated;
      }

      Array.from(this.el.querySelectorAll('ion-fab-list')).forEach(function (list) {
        list.activated = activated;
      });
    }
  }, {
    key: "componentDidLoad",
    value: function componentDidLoad() {
      if (this.activated) {
        this.activatedChanged();
      }
    }
    /**
     * Close an active FAB list container.
     */

  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.activated = false;

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "getFab",
    value: function getFab() {
      return this.el.querySelector('ion-fab-button');
    }
  }, {
    key: "render",
    value: function render() {
      var _class;

      var horizontal = this.horizontal,
          vertical = this.vertical,
          edge = this.edge;
      var mode = getIonMode(this);
      return h(Host, {
        onClick: this.onClick,
        class: (_class = {}, _defineProperty(_class, mode, true), _defineProperty(_class, "fab-horizontal-".concat(horizontal), horizontal !== undefined), _defineProperty(_class, "fab-vertical-".concat(vertical), vertical !== undefined), _defineProperty(_class, 'fab-edge', edge), _class)
      }, h("slot", null));
    }
  }, {
    key: "el",
    get: function get() {
      return this;
    }
  }], [{
    key: "watchers",
    get: function get() {
      return {
        "activated": ["activatedChanged"]
      };
    }
  }, {
    key: "style",
    get: function get() {
      return fabCss;
    }
  }]);

  return Fab;
}(HTMLElement);

Fab = /*@__PURE__*/proxyCustomElement(Fab, [1, "ion-fab", {
  "horizontal": [1],
  "vertical": [1],
  "edge": [4],
  "activated": [1028],
  "close": [64]
}]);

function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }

  var components = ["ion-fab"];
  components.forEach(function (tagName) {
    switch (tagName) {
      case "ion-fab":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, Fab);
        }

        break;
    }
  });
}

var IonFab = Fab;
var defineCustomElement = defineCustomElement$1;
export { IonFab, defineCustomElement };